import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative h-[300px] md:h-[450px] bg-secondary-100 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20reading%20experience%20on%20mobile%20device%2C%20warm%20beige%20and%20cream%20tones%2C%20digital%20comic%20scroll%20interface%2C%20clean%20modern%20design%2C%20soft%20ambient%20lighting%2C%20minimalist%20composition&width=1200&height=900&seq=cta-reading-hanman&orientation=landscape"
          alt="下拉式韩漫阅读体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-100/50 to-transparent"></div>
        <div className="absolute top-6 left-6">
          <span className="text-xs font-light text-foreground-700 whitespace-nowrap">随时随地 · 畅享阅读</span>
        </div>
        <div className="absolute bottom-6 left-6">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            下拉式<br />韩漫阅读<br />全新体验
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center py-14 md:py-20 px-6 md:px-12">
        <div className="max-w-md text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
            开始你的<br />无删减韩漫之旅
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，资源丰富多元，无广告干扰。无论你钟爱奇幻冒险、甜蜜恋爱还是悬疑动作，这里都有你想要的精彩内容。现在就加入，畅享纯净阅读时光！
          </p>
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 dark:text-foreground-950 px-7 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap group"
          >
            立即免费阅读
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}